import { Injectable, Inject, forwardRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { OrganisationSubscriptionInvoiceResponse } from '../../_models/billing-pricing/OrganisationSubscriptionInvoice'
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IApiRequest, IApiresponse } from '../../_models';
import { IYearlySupportprice, OrgInvoiceCheckRequest, OrgInvoiceCheckResponse, OrgSubscription,UpdateOrganisationSubscriptionInvoiceStatusRequest } from '../../_models/common/OrgSubscription';
import { ClaimsHeaderService } from 'src/app/shared/claimsHeader/claims-header.service';
//import { setHeader } from 'src/app/_helpers/setRequestHeader';



@Injectable({
  providedIn: 'root'
})
export class OrganisationSubscriptionInvoiceService {

  constructor(private http: HttpClient, private claimsHeaderService: ClaimsHeaderService) { }

  GetOrganisationSubscriptionInvoiceList(requestinfo: IApiRequest<OrgSubscription>): Observable<IApiresponse<OrganisationSubscriptionInvoiceResponse[]>> {
    const url = `${environment.billingApiUrl}OrganisationSubscriptionInvoice`;
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<OrganisationSubscriptionInvoiceResponse[]>>(url, body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetOrganisationInvoiceFailedRecords(orgId: number): Observable<IApiresponse<any>> {
    let params = new HttpParams();
    params = params.append("orgId", orgId.toString());
    return this.http.get<IApiresponse<any>>(`${environment.billingApiUrl}GetOrganisationInvoiceFailedRecords`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}

UpdateOrganisationSubscriptionInvoiceStatus(requestinfo: IApiRequest<UpdateOrganisationSubscriptionInvoiceStatusRequest>): Observable<IApiresponse<any[]>> {
  const url = `${environment.billingApiUrl}UpdateOrganisationSubscriptionInvoiceStatus`;
  let body = JSON.stringify(requestinfo);
  return this.http.post<IApiresponse<any[]>>(url, body,
    { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
  );
}

GetPOReceipt(orgId: number): Observable<IApiresponse<string>> {
  let params = new HttpParams();
  params = params.append("orgId", orgId.toString());
  return this.http.get<IApiresponse<string>>(`${environment.billingApiUrl}GetPOReceipt`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}

GetPriceForYearlySupport(): Observable<IApiresponse<IYearlySupportprice[]>> {
  let params = new HttpParams();
  return this.http.get<IApiresponse<IYearlySupportprice[]>>(`${environment.billingApiUrl}GetPriceForYearlySupport`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}


GetInvoiceData(invoiceDataPath: string): Observable<IApiresponse<any>> {
  let params = new HttpParams();
  params = params.append("invoiceDataPath", invoiceDataPath.toString());
  return this.http.get<IApiresponse<any>>(`${environment.billingApiUrl}GetInvoiceData`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
}

checkInvoiceDateWithRequest(requestinfo: IApiRequest<OrgInvoiceCheckRequest>): Observable<IApiresponse<OrgInvoiceCheckResponse>> {
  const url = `${environment.billingApiUrl}CheckInvoiceDateWithRequest`;
  let body = JSON.stringify(requestinfo);
  return this.http.post<IApiresponse<OrgInvoiceCheckResponse>>(url, body,
    { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
  );
}

checkIfReminderRequired(orgInvoiceCheckRequest: OrgInvoiceCheckRequest): Observable<boolean> {
  return new Observable<boolean>(observer => {
    const requestInfo: IApiRequest<OrgInvoiceCheckRequest> = {
      webApiName: "CheckInvoiceDateWithRequest",
      webApiVersion: environment.applicationVersion,
      requestId: environment.requestId,
      requestInfo: orgInvoiceCheckRequest
    };

    this.checkInvoiceDateWithRequest(requestInfo).subscribe({
      next: (response: IApiresponse<OrgInvoiceCheckResponse>) => {
        if (response &&  response.responseInfo) {
          // Check if audit trail reminder panel is required based on response
          const shouldShowReminder = response.responseInfo.panelRequired;
          observer.next(shouldShowReminder);
        } else {
          // Default to false if API call fails or returns unexpected response
          observer.next(false);
        }
        observer.complete();
      },
      error: (error) => {
        console.error('Error checking audit trail reminder requirements:', error);
        // Default to false on error
        observer.next(false);
        observer.complete();
      }
    });
  });
}



}
